import { api } from './client';

export interface NotificationActorDto {
  id: string;
  displayName: string;
  email: string;
}

export interface NotificationDto {
  id: string;
  userId: string;
  actorId: string | null;
  actor: NotificationActorDto | null;
  type: string;
  title: string;
  body: string | null;
  linkPath: string | null;
  resourceType: string | null;
  resourceId: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationListResponse {
  items: NotificationDto[];
  nextCursor: string | null;
}

export interface NotificationListQuery {
  unreadOnly?: boolean;
  limit?: number;
  cursor?: string | null;
}

export const notificationsApi = {
  list: (q: NotificationListQuery = {}) =>
    api<NotificationListResponse>('/notifications', {
      query: {
        ...(q.unreadOnly !== undefined ? { unreadOnly: q.unreadOnly } : {}),
        ...(q.limit !== undefined ? { limit: q.limit } : {}),
        ...(q.cursor ? { cursor: q.cursor } : {}),
      },
    }),
  unreadCount: () => api<{ count: number }>('/notifications/unread-count'),
  markRead: (id: string) =>
    api<void>(`/notifications/${id}/read`, { method: 'POST' }),
  markAllRead: () =>
    api<{ count: number }>('/notifications/mark-all-read', { method: 'POST' }),
  remove: (id: string) =>
    api<void>(`/notifications/${id}`, { method: 'DELETE' }),
};
